module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-EVA_2.89774d7a.jpg";